<template>
  <div>
    <Header Act="4"></Header>
  <div class="works-show">
    <!-- 样品展示区域 -->
    <!-- <div class="sample-show">
      <h2>样品展示</h2>
      <div class="sample-list" >
        <div class="sample-item" @click="showArticle">
          <div class="sample-title">科普文章样稿</div>
          <div class="sample-arrow">
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
        <div class="sample-item" @click="showVideo">
          <div class="sample-title">科普视频样片</div>
          <div class="sample-arrow">
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>
    </div> -->

    <!-- 优秀作品库 -->
    <div class="works-library">
      <div class="library-header">
        <h2>优秀作品库</h2>
        <router-link to="/works/all?type=excellent" class="view-all">查看全部</router-link>
      </div>
      <div class="video-list">
        <div v-for="(video) in displayExcellentList" :key="video.id" class="video-item" @click="goToVideo(video, true)">
          <div class="video-player-wrap">
            <div class="video-container">
              <template v-if="video.worksType === '1' || video.worksType === '2'">
                <img :src="video.poster" class="doc-icon full-cover" alt="封面">
              </template>
              <template v-else>
                <!-- 视频类型显示视频 -->
                <div class="video-thumbnail-container">
                  <video 
                    :src="video.url" 
                    class="video-cover" 
                    :poster="video.poster"
                    muted
                    playsinline
                    webkit-playsinline
                    x5-video-player-type="h5"
                    x5-video-player-fullscreen="true"
                    x5-video-orientation="portraint"
                    x-webkit-airplay="allow"
                  ></video>
                  <div v-if="loadingThumbnails[video.id]" class="loading-overlay">
                    <i class="el-icon-loading"></i>
                  </div>
                </div>
              </template>
            </div>
            <div class="play-icon" v-if="!video.id && (video.worksType === '3' || video.worksType === '4')">
              <i class="el-icon-video-play"></i>
            </div>
          </div>
          <div class="video-title">{{ video.title }}</div>
        </div>
      </div>
    </div>

    <!-- 科普作品库 -->
    <div class="works-library">
      <div class="library-header">
        <h2>科普作品库</h2>
        <router-link to="/works/all" class="view-all">查看全部</router-link>
      </div>
      <div class="video-list">
        <div v-for="(video) in displayVideoList" :key="video.id" class="video-item" @click="goToVideo(video)">
          <div class="video-player-wrap">
            <div class="video-container">
              <template v-if="video.worksType === '1' || video.worksType === '2'">
                <img :src="video.poster" class="doc-icon full-cover" alt="封面">
              </template>
              <template v-else>
                <!-- 视频类型显示视频 -->
                <div class="video-thumbnail-container">
                  <video 
                    :src="video.url" 
                    class="video-cover" 
                    :poster="video.poster"
                    muted
                    playsinline
                    webkit-playsinline
                    x5-video-player-type="h5"
                    x5-video-player-fullscreen="true"
                    x5-video-orientation="portraint"
                    x-webkit-airplay="allow"
                  ></video>
                  <div v-if="loadingThumbnails[video.id]" class="loading-overlay">
                    <i class="el-icon-loading"></i>
                  </div>
                </div>
              </template>
            </div>
            <div class="play-icon" v-if="!video.id && (video.worksType === '3' || video.worksType === '4')">
              <i class="el-icon-video-play"></i>
            </div>
          </div>
          <div class="video-title">{{ video.title }}</div>
        </div>
      </div>
    </div>
  </div>
  <Footer></Footer>
  </div>
</template>

<script>
import Header from '../header/head.vue';
import Footer from '../header/footer.vue';
import { allVideos } from '@/data/videos.js'; // 导入视频数据
import axios from 'axios'; // 导入axios

// 配置axios默认值
axios.defaults.baseURL = process.env.VUE_APP_BASE_API || 'http://localhost:8080';
axios.defaults.headers.common['Content-Type'] = 'application/json';

export default {
  name: 'WorksShow',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      videoDialogVisible: false,
      currentVideo: null,
      apiVideos: [], // 普通作品数据
      excellentVideos: [], // 优秀作品数据
      defaultPoster: 'https://bxxcx.bahim.org.cn/profile/upload/2025/03/06/logo.jpg',
      wordIcon: require('../../assets/applyRey/word.png'),
      loadingThumbnails: {},
      isExcellentWorks: false,
      videos: [],
      thumbnailPromises: [], // 存储所有缩略图生成的Promise
      activeVideoElements: new Set(), // 存储活动的视频元素
      isComponentActive: true // 标记组件是否处于活动状态
    }
  },
  computed: {
    displayVideoList() {
      // 首先过滤掉 ID 为 'video_00' 的视频
      const filteredVideos = allVideos.filter(video => video.id !== 'video_00');
      
      // 将API获取的视频数据转换为与本地数据相同的格式
      const formattedApiVideos = this.apiVideos.map(video => {
        let videoUrl = video.vedioFile || '';
        let posterUrl = video.picFile
          ? video.picFile.replace('http://bxxcxbackend.bahim.org.cn', 'https://bxxcx.bahim.org.cn')
          : this.defaultPoster;
        return {
          id: video.id,
          title: video.worksName,
          description: video.des || '',
          author: video.userName || '',
          organization: video.userUnit || '',
          url: videoUrl,
          projectTheme: video.projectCase || '无',
          poster: posterUrl,
          worksType: video.worksType
        };
      }).filter(video => video.url);
      // 先放API数据，再放本地数据
      const allVideosList = [...formattedApiVideos, ...filteredVideos];
      if (typeof window !== 'undefined' && window.innerWidth <= 768) {
        return allVideosList.slice(0, 4);
      }
      return allVideosList.slice(0, 6);
    },
    displayExcellentList() {
      // 将优秀作品数据转换为统一格式
      const formattedExcellentVideos = this.excellentVideos.map(video => {
        let videoUrl = video.vedioFile || '';
        let posterUrl = video.picFile
          ? video.picFile.replace('http://bxxcxbackend.bahim.org.cn', 'https://bxxcx.bahim.org.cn')
          : this.defaultPoster;
        return {
          id: video.id,
          title: video.worksName,
          description: video.des || '',
          author: video.userName || '',
          organization: video.userUnit || '',
          url: videoUrl,
          projectTheme: video.projectCase || '无',
          poster: posterUrl,
          worksType: video.worksType
        };
      }).filter(video => video.url);
      if (typeof window !== 'undefined' && window.innerWidth <= 768) {
        return formattedExcellentVideos.slice(0, 4);
      }
      return formattedExcellentVideos.slice(0, 6);
    }
  },
  methods: {
    // 初始化数据
    async initData() {
      try {
        // 并行获取普通作品和优秀作品数据
        await Promise.all([
          this.fetchApiVideos(),
          this.fetchExcellentVideos()
        ]);
      } catch (error) {
        console.error('初始化数据失败:', error);
      }
    },
    handleResize() {
      this.$forceUpdate();
    },
    showArticle() {
      this.$router.push('/Sample')
    },
    showVideo() {
      const sampleVideoId = 'video_00'; 
      this.$router.push({
        path: '/sample-video',
        query: { 
          videoId: sampleVideoId
        }
      });
    },
    onVideoLoaded(event) {
      const video = event.target;
      video.muted = true;
      video.style.display = 'block';
    },
    goToVideo(video, isExcellent = false) {
      if (!video || !video.id) {
        console.error('goToVideo: video object or video.id is undefined', video);
        return;
      }
      // 根据是否是优秀作品选择不同的参数名
      const queryParam = isExcellent ? 'goodvideoId' : 'videoId';
      this.$router.push({
        path: '/sample-video',
        query: { 
          [queryParam]: video.id
        }
      });
    },
    // 重置所有视频状态
    resetAllVideos() {
      if (this.$refs.videoRefs) {
        this.$refs.videoRefs.forEach(video => {
          if (video) {
            video.pause();
            video.src = '';
            video.load();
          }
        });
      }
      if (this.$refs.excellentVideoRefs) {
        this.$refs.excellentVideoRefs.forEach(video => {
          if (video) {
            video.pause();
            video.src = '';
            video.load();
          }
        });
      }
    },
    // 清理所有视频相关资源
    cleanupVideoResources() {
      this.apiVideos = [];
      this.excellentVideos = [];
      this.videos = [];
    },
    // 获取普通作品列表
    async fetchApiVideos() {
      try {
        const response = await axios.get('/system/works/jianji/list');
        if (response.data.code === 200) {
          this.apiVideos = response.data.rows || [];
          // 获取数据后合并数据
          this.mergeVideoData();
        } else {
          console.error('获取视频列表失败:', response.data.msg);
        }
      } catch (error) {
        console.error('获取视频列表出错:', error);
        this.apiVideos = [];
      }
    },

    // 获取优秀作品列表
    async fetchExcellentVideos() {
      try {
        const response = await axios.get('/system/works/goodjianji/list');
        if (response.data.code === 200) {
          this.excellentVideos = response.data.rows || [];
          // 获取数据后合并数据
          this.mergeVideoData();
        } else {
          console.error('获取优秀作品列表失败:', response.data.msg);
        }
      } catch (error) {
        console.error('获取优秀作品列表出错:', error);
        this.excellentVideos = [];
      }
    },

    // 合并本地和API数据
    mergeVideoData() {
      // 将API视频数据转换为统一格式
      const formattedApiVideos = this.apiVideos.map(video => {
        // 根据worksType判断使用哪个视频路径和封面图
        let videoUrl = '';
        let posterUrl = this.defaultPoster;

        switch(video.worksType) {
          case '1': // 文档类型
            videoUrl = video.vedioFile || '';
            posterUrl = this.wordIcon;
            break;
          case '2': // 图片类型
            videoUrl = video.vedioFile || '';
            posterUrl = video.picFile ? video.picFile.replace('http://bxxcxbackend.bahim.org.cn', 'https://bxxcx.bahim.org.cn') : this.defaultPoster;
            break;
          case '3': // 视频类型
          case '4': // 剪辑视频类型
            videoUrl = video.vedioFile || '';
            posterUrl = video.picFile ? video.picFile.replace('http://bxxcxbackend.bahim.org.cn', 'https://bxxcx.bahim.org.cn') : this.defaultPoster;
            break;
        }

        return {
          id: video.id,
          title: video.worksName,
          description: video.des || '',
          author: video.userName || '',
          organization: video.userUnit || '',
          url: videoUrl,
          projectTheme: video.projectCase || '无',
          poster: posterUrl,
          worksType: video.worksType
        };
      }).filter(video => video.url);

      // 设置视频列表
      if (this.isExcellentWorks) {
        this.videos = formattedApiVideos;
      } else {
        const localVideos = allVideos.filter(video => video.id !== 'video_00');
        this.videos = [...formattedApiVideos, ...localVideos];
      }
    },
  },
  mounted() {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.handleResize);
    }
    // 初始化数据
    this.initData();
  },
  beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.handleResize);
    }
    // 清理所有视频相关资源
    this.cleanupVideoResources();
  },
  activated() {
    // 组件被激活时重置状态
    this.$nextTick(() => {
      this.resetAllVideos();
    });
  },
  deactivated() {
    // 组件被停用时清理视频状态
    this.cleanupVideoResources();
  }
}
</script>

<style scoped>
.works-show {
  padding: 20px;
}

.sample-show {
  margin-bottom: 40px;
}

.sample-list {
  margin-top: 20px;
}

.sample-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f5f7fa;
  border-radius: 8px;
  padding: 15px 20px;
  cursor: pointer;
  transition: all 0.3s;
  margin-bottom: 10px;
}

.sample-item:last-child {
  margin-bottom: 0;
}

.sample-item:hover {
  background: #ecf5ff;
}

.sample-title {
  font-size: 16px;
  color: #333;
}

.sample-arrow {
  color: #999;
  font-size: 16px;
}

.sample-item:hover .sample-arrow {
  color: #409EFF;
}

.library-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.view-all {
  color: #58C1B6;
  text-decoration: none;
  transition: color 0.3s ease;
}

.view-all:hover {
  color: #4BA89E;
}

/* 改为类似于网格布局，但保持其灵活性 */
.video-list {
  display: flex;
  gap: 20px;
  padding-bottom: 20px;
  flex-wrap: wrap;
  justify-content: flex-start;
}

/* 确保每个视频项都有固定宽度 */
.video-item {
  width: 248px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.video-player-wrap {
  width: 248px;
  height: 440px;
  background: #000;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.video-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000;
}

.video-cover {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block; /* 修改为block，确保封面图片可见 */
  background: #000;
}

/* 添加与AllWorks.vue相同的宽高比适配规则 */
@media screen and (min-aspect-ratio: 16/9) {
  .video-cover {
    width: 100%;
    height: auto;
  }
}

@media screen and (max-aspect-ratio: 16/9) {
  .video-cover {
    width: auto;
    height: 100%;
  }
}

.play-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
  z-index: 1;
}

.play-icon i {
  color: #fff;
  font-size: 30px;
}

.video-player-wrap:hover .play-icon {
  background: rgba(0, 0, 0, 0.7);
  transform: translate(-50%, -50%) scale(1.1);
}

.video-title {
  margin-top: 8px;
  font-size: 14px;
  text-align: center;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 5px;
  width: 100%;
  max-width: 248px;
}

@media screen and (max-width: 768px) {
  .video-list {
    gap: 10px;
    justify-content: space-between;
  }

  .video-item {
    width: calc(50% - 5px);
    margin-bottom: 10px;
  }

  .video-player-wrap {
    width: 100%;
    height: 200px;
  }

  .video-cover {
    width: 100%;
    height: 100%;
    object-fit: cover;
    background: #000;
  }

  .play-icon {
    width: 40px;
    height: 40px;
  }

  .play-icon i {
    font-size: 20px;
  }

  .video-title {
    font-size: 12px;
    margin-top: 5px;
    width: 100%;
    max-width: 100%;
  }
}

/* 添加优秀作品库的间距 */
.works-library + .works-library {
  margin-top: 40px;
}

@media screen and (max-width: 768px) {
  .works-library + .works-library {
    margin-top: 30px;
  }
}

.doc-icon {
  width: 64px;
  height: 64px;
  object-fit: contain;
  margin: auto;
}

/* 新增：让文档类型图片左右撑满容器，上下自适应 */
.full-cover {
  width: 100% !important;
  height: auto !important;
  object-fit: contain !important;
  margin: 0 !important;
}

.image-cover {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* 确保视频容器在所有类型下都保持一致的外观 */
.video-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
}

/* 调整文档图标容器的样式 */
.video-player-wrap:has(.doc-icon) {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
}

.video-thumbnail-container {
  position: relative;
  width: 100%;
  height: 100%;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.video-cover {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
}

/* 横向视频的特殊处理 */
.video-cover.landscape {
  width: 100%;
  height: auto;
}

/* 竖向视频的特殊处理 */
.video-cover.portrait {
  width: auto;
  height: 100%;
}

/* 确保容器比例一致 */
.video-player-wrap {
  position: relative;
  width: 248px;
  height: 440px;
  background: #000;
  border-radius: 8px;
  overflow: hidden;
}

@media screen and (max-width: 768px) {
  .video-player-wrap {
    width: 100%;
    height: 200px;
  }
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-overlay i {
  font-size: 24px;
  color: #409EFF;
}
</style> 